import {
  Box,
  BoxProps,
  ColorOptions,
  convertHexToRGBA,
  Loader,
  ModalDialogNew,
  ModBox,
  Spacer,
  Text,
  TextProps,
} from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { FlatList, Text as RNText, Platform, View } from 'react-native'
import EmptyView from '../../comps/EmptyView'
import { HeaderLeft } from '../../comps/MobileCustomHeader/HeaderLeft'
import { SvgImage } from '../../comps/SvgImage'
import { useLazyApiData, useStores } from '../../data/store'
import { Colors, convertDateToMonthAndYear, hasPermissions } from '../../util/util'
import { InvoiceDetails } from './InvoiceDetails'

const tidTextStyle = {
  color: convertHexToRGBA('#000', 65),
  fontSize: 12,
  lineHeight: 16,
  fontFamily: 'JioType-Medium',
}
import { color } from 'styled-system'

const RenderItem = ({ item, onSelect }: any) => {
  const paidAmount = parseFloat(item?.totalCharges).toFixed(2)
  const paidDate = convertDateToMonthAndYear(item?.paidOn)
  // console.log('paidDate', paidDate)
  return (
    <Box
      testID="rental-txn"
      onPress={() => onSelect({ ...item, paidAmount: paidAmount, paidDate: paidDate })}
      flexDirection={'row'}
      alignItems={'center'}
      underlayColor="TRANSPARENT"
      marginVertical={15}>
      <Box
        bg={convertHexToRGBA(Colors.PRIMARY, 6) as ColorOptions}
        width={40}
        height={40}
        borderRadius={20}
        overflow="hidden"
        alignItems={'center'}
        justify="center">
        <SvgImage imageName="BillIcon" color={Colors.PRIMARY} />
      </Box>
      <Spacer size={15} direction="horizontal" />
      <Box f={1}>
        <Text lineHeight={20} color={Colors.BLACK_14 as ColorOptions} fontSize={14} fontFamily="JioType-Bold">
          {paidDate ?? item?.paidOn}
        </Text>
        <Spacer size={8} direction="horizontal" />
        <RNText numberOfLines={1} ellipsizeMode={'tail'} style={tidTextStyle}>
          {`Transaction ID: ${item?.txnId}`}
        </RNText>
      </Box>
      <Box align="flex-end" pl={10}>
        <Text lineHeight={20} color={Colors.BLACK_14 as ColorOptions} fontSize={14} fontFamily="JioType-Bold">
          ₹{paidAmount}
        </Text>
        <Text
          testID="txn-status"
          lineHeight={16}
          {...styles.getStatusColor(item?.status)}
          fontSize={12}
          fontFamily="JioType-Medium">
          {item?.status === 'SUCCESS' ? 'PAID' : item?.status}
        </Text>
      </Box>
    </Box>
  )
}

const RentalHistory = () => {
  const navigation = useNavigation()
  const params = useRoute()?.params ?? {}
  const { id }: any = params
  const { fetchInvoices, downloadInvoicePdf, getInvoices, device } = useStores((store) => ({
    fetchInvoices: store.voiceBoxes.fetchInvoices,
    getInvoices: store.voiceBoxes.getAllInvoices(id),
    downloadInvoicePdf: store.voiceBoxes.downloadInvoicePdf,
    device: store.voiceBoxes.getVoiceBox(id),
  }))

  const [showModal, setShowModal] = useState(false)
  const [selectedData, setSelectedData]: any = useState({})
  const [invoices, setInvoices]: any = useState(getInvoices ?? [])

  const [fetchInvoicesApi, { state: invoiceState, data: invoicesData }] = useLazyApiData(fetchInvoices)
  const [downloadInvoicePdfApi, { state: downloadApiState }] = useLazyApiData(downloadInvoicePdf)
  const [shareInvoicePdfApi, { state: shareApiState }] = useLazyApiData(downloadInvoicePdf)

  useEffect(() => {
    fetchInvoicesApi(id)
  }, [id, fetchInvoicesApi])

  useEffect(() => {
    if (invoiceState === 'fulfilled') {
      setInvoices(invoicesData ?? [])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceState])


  const headerLeft = () => {
    return (
      <Box backgroundColor={'TRANSPARENT'} flexDirection="row" justifyContent="center" alignItems={'center'} h={64}>
        <ModBox
          paddingLeft={25}
          paddingRight={10}
          top={ Platform.OS === 'ios' ? -50 : 0 }
          show={navigation?.canGoBack()}
          underlayColor={'TRANSPARENT'}
          testID="back-arrow"
          onPress={() => navigation?.goBack()}>
          <SvgImage imageName="HeaderArrowLeft" />
        </ModBox>
      </Box>
    )
  }

  useEffect(() => {
    navigation?.setOptions({
      title: 'Rental History',
      headerTintColor: '#fff',
      headerBackVisible: true,
      headerTransparent: true,
      headerLeft:Platform.OS === 'ios' ? headerLeft : () => <HeaderLeft />,
      headerStyle: { backgroundColor: '#966D2E' },
      headerTitleStyle: {
        fontSize: 16,
        fontFamily: 'JioType-Bold',
        top: Platform.OS === 'ios' ? -50 : 0,
      },
    })
  }, [navigation])

  const handleSelect = (item: any) => {
    setShowModal(true)
    setSelectedData(item)
  }

  const handleDownload = () => {
    hasPermissions()?.then((granted) => {
      if (granted) {
        downloadInvoicePdfApi(selectedData?.id)
      } else {
        console.log('permission denied')
      }
    })
  }

  const handleShare = () => {
    hasPermissions()?.then((granted) => {
      if (granted) {
        shareInvoicePdfApi(selectedData?.id, true)
      } else {
        console.log('permission denied')
      }
    })
  }

  return (
    <View style={{flex: 1,backgroundColor: Colors.SECONDARY}}>
    <Box flex={1} backgroundColor="SECONDARY" position={'relative'}>
      <Spacer size={60} direction="vertical" />
      <Box flex={1} {...styles.listWrapper}>
        <EmptyView
          onRetry={() => fetchInvoicesApi()}
          isLoading={invoiceState === 'pending'}
          error={!!invoicesData?.message}
          emptyMessage={'No data found'}
          loadingMessage={'Loading...'}
          hide={invoiceState === 'fulfilled' && invoices?.length > 0}
          testID={'voiceboxInvoiceEmptyView'}
        />
        <FlatList
          data={[...invoices]}
          renderItem={({ item }) => <RenderItem deviceId={id} onSelect={handleSelect} item={item} />}
          extraData={invoices}
        />
      </Box>

      <ModalDialogNew animate={true} show={showModal} type="bottom" backgroundColor="TRANSPARENT">
        <Box borderTopLeftRadius={30} borderTopRightRadius={30} bg="WHITE" overflow={'hidden'}>
          <Spacer size={10} direction="vertical" />
          <Box flexDirection={'row'} justifyContent="space-between" alignItems={'flex-start'} mb={20} mt={30} ph={25}>
            <Box width={'90%'}>
              <ModBox show={selectedData?.paidDate !== 'NA'}>
                <Text fontFamily="JioType-Black" fontSize={24}>
                  {selectedData?.paidDate}
                </Text>
              </ModBox>
              <Spacer size={5} direction="vertical" />
              <Text color={Colors.BLACK_14 as ColorOptions} fontSize={14} fontFamily="JioType-Medium">
                Transaction ID: {selectedData?.txnId}
              </Text>
              <Spacer size={10} direction="vertical" />
              <Box alignItems="flex-start">
                <Box {...styles.getStatusBgColor(selectedData?.status)} borderRadius={4} pv={6} ph={10}>
                  <Text fontFamily="JioType-Bold" fontSize={12} color={'WHITE'}>
                    {selectedData?.status === 'SUCCESS' ? 'PAID' : selectedData?.status}
                  </Text>
                </Box>
              </Box>
            </Box>
            <Box
              testID="close"
              onPress={() => {
                setShowModal(false)
                setSelectedData({})
              }}
              underlayColor={'TRANSPARENT'}>
              <SvgImage imageName="Close" />
            </Box>
          </Box>
          <Spacer size={10} direction="vertical" />
          <InvoiceDetails data={selectedData} />
          <Spacer size={10} direction="vertical" />
          <ModBox
            show={selectedData?.status === 'SUCCESS'}
            justifyContent="space-between"
            alignItems={'center'}
            flexDirection={'row'}
            ph={25}
            marginVertical={20}>
            <Box
              testID="share"
              onPress={handleShare}
              disabled={shareApiState === 'pending'}
              flexDirection={'row'}
              alignItems="center"
              justifyContent={'center'}
              borderWidth={1}
              borderRadius={55}
              borderColor={'PRIMARY'}
              flex={0.5}
              underlayColor="TRANSPARENT"
              height={55}>
              {shareApiState === 'pending' ? (
                <Loader type={'small'} color="PRIMARY" />
              ) : (
                <>
                  <SvgImage color={Colors.PRIMARY} imageName={'Share'} />
                  <Spacer size={8} direction="horizontal" />
                  <Text fontFamily="JioType-Medium" fontSize={16} color={'PRIMARY'}>
                    Share
                  </Text>
                </>
              )}
            </Box>
            <Spacer size={15} direction="horizontal" />
            <Box
              testID="download"
              onPress={handleDownload}
              disabled={downloadApiState === 'pending'}
              flexDirection={'row'}
              alignItems="center"
              borderWidth={1}
              borderRadius={55}
              borderColor={'PRIMARY'}
              justifyContent={'center'}
              underlayColor="TRANSPARENT"
              flex={0.5}
              height={55}>
              {downloadApiState === 'pending' ? (
                <Loader type={'small'} color="PRIMARY" />
              ) : (
                <>
                  <SvgImage color={Colors.PRIMARY} imageName={'Download'} />
                  <Spacer size={8} direction="horizontal" />
                  <Text fontFamily="JioType-Medium" fontSize={16} color={'PRIMARY'}>
                    Download
                  </Text>
                </>
              )}
            </Box>
          </ModBox>
        </Box>
      </ModalDialogNew>
    </Box>
    </View>
  )
}
const styles = {
  listWrapper: {
    backgroundColor: 'WHITE',
    padding: 25,
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    width: '100%',
    zIndex: 4,
    overflow: 'auto',
  } as BoxProps,
  getStatusColor: (status: any) =>
    ({
      color:
        status === 'SUCCESS'
          ? Colors.GREEN_SUCCESS_BG
          : status === 'ERROR' || status === 'FAILED'
          ? Colors.GREEN_ERROR_BG
          : 'TEXT_TERTIARY',
    } as TextProps),
  getStatusBgColor: (status: any) =>
    ({
      bg:
        status === 'SUCCESS'
          ? (Colors.GREEN_SUCCESS_BG as ColorOptions)
          : status === 'ERROR' || status === 'FAILED'
          ? Colors.GREEN_ERROR_BG
          : 'BG_PRIMARY_PENDING',
    } as BoxProps),
}
export default RentalHistory
